
import React, { useState, useEffect, useCallback } from 'react';
import './Shell.css';
import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import BottomTabBar from '../BottomTabBar/BottomTabBar';
import CommandPalette from '../CommandPalette/CommandPalette';
import ToastContainer from '../Toast/ToastContainer';
import { useAppState } from '../../context/AppStateContext';
import PageRenderer from '../PageRenderer/PageRenderer';
import { ToastContext, useToastProvider } from '../../context/ToastContext';

export default function Shell() {
  const { appState, setAppState } = useAppState();
  const toastCtx = useToastProvider();
  const [mobile, setMobile] = useState(window.innerWidth < 768);
  const [tablet, setTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 1024);

  useEffect(() => {
    const handler = () => {
      const w = window.innerWidth;
      setMobile(w < 768);
      setTablet(w >= 768 && w < 1024);
    };
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  const toggleCommandPalette = useCallback(() => {
    setAppState(s => ({ ...s, commandPaletteOpen: !s.commandPaletteOpen }));
  }, [setAppState]);

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        toggleCommandPalette();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [toggleCommandPalette]);

  const collapsed = mobile ? false : (tablet ? true : appState.sidebarCollapsed);
  const isMedia = appState.currentPage === 'studio' && appState.studioTab === 'media';

  return (
    <ToastContext.Provider value={toastCtx}>
      <div className="shell">
        {!isMedia && (
          <Header onCommandPalette={toggleCommandPalette} mobile={mobile} />
        )}
        <div className="shell__body">
          {!mobile && !isMedia && <Sidebar collapsed={collapsed} />}
          <main
            className={`shell__main${isMedia ? ' shell__main--immersive' : ''}`}
            style={{
              paddingBottom: mobile ? `calc(var(--bottom-bar-height) + 8px)` : undefined,
            }}
          >
            <PageRenderer />
          </main>
        </div>
        {mobile && <BottomTabBar onSearch={toggleCommandPalette} />}
        {appState.commandPaletteOpen && (
          <CommandPalette onClose={toggleCommandPalette} />
        )}
        <ToastContainer toasts={toastCtx.toasts} removeToast={toastCtx.removeToast} />
      </div>
    </ToastContext.Provider>
  );
}
